// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { headerSignInStyles } from "@eisinc/Overrides/Widgets/Common/HeaderSignIn";
import Account from "@eisinc/XDL/Icons/Account";
import SignIn from "@eisinc/XDL/Icons/SignIn";
import { css } from "styled-components";

headerSignInStyles.tooltip = {
    tooltipContent: {
        css: css`
            padding: 0;
            max-width: 100%;
        `,
    },
    drawerContent: {
        css: css`
            width: 400px;
        `,
    },
};

headerSignInStyles.myAccountTooltip = {
    tooltipContent: {
        css: css`
            padding: 0;
            max-width: 100%;
        `,
    },
    drawerContent: {
        css: css`
            width: 430px;
        `,
    },
};

headerSignInStyles.signInHeaderClickable = {
    icon: {
        src: SignIn,
    },
};

headerSignInStyles.myAccountHeaderClickable = {
    icon: {
        src: Account,
    },
};

headerSignInStyles.signOutWrapper = {
    css: css`
        display: inline-flex;
    `,
};
